import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { BehaviorSubject } from 'rxjs';
import {
  createConnection,
  getConnection,
  getRepository,
  Table, TableColumn,
  TableForeignKey,
  TableIndex,
  TableUnique,
} from 'typeorm';
import { Config } from '../config';
import { Check } from '../entities/Check';
import { VersionService } from './version.service';

@Injectable({
  providedIn: 'root'
})
export class DbService {

  connection: any;
  dbIsReady: BehaviorSubject<boolean>;
  constructor(private versionService: VersionService) {
    this.dbIsReady = new BehaviorSubject(false);
  }

  async initConnection() {
    const connectionParams = this.versionService.isMobileDevice() ? Config.databaseConfig.cordova : Config.databaseConfig.browser;
    // this.connection = await createConnection(connectionParams);

    // this.dbIsReady.next(true);
    // console.log('Start creating connection', connectionParams);

    return createConnection(connectionParams).then(connection => {
      this.connection = connection;
      this.dbIsReady.next(true);

    }).catch(err => { console.log('err opening db', err) });
  }

  async runMigrationToRemoveRankingVerificationUniqueConstraint() {
    const queryRunner = this.connection.createQueryRunner();
    const table = await queryRunner.getTable('ranking');
    const records = await queryRunner.query('SELECT * FROM "ranking"');
    console.log(records);
    const uniqueConstraint = table?.uniques.find((uq) => uq.columnNames.includes('verificationId'));
    if (uniqueConstraint !== undefined) {
      // Because Sqlite doesn't support to drop one constraint, we must recreate table without this unique constraint
      // Create a new table with the same columns (but no constraints yet)
      await queryRunner.query('DROP TABLE IF EXISTS "ranking_temp"');
      const newTable = new Table({
        name: 'ranking_temp',
        columns: table.columns.filter(column => column.name !== 'verificationId'),
      });
      newTable.addColumn(new TableColumn({
        name: 'verificationId',
        type: 'integer',
        isNullable: true,
      }));

      // Recreate unique constraints
      if (table?.uniques) {
        table?.uniques.forEach(uniqueConstraint => {
          if (!uniqueConstraint.columnNames.every((value, index) => value === ['verificationId'][index])) {
            newTable.addUniqueConstraint(new TableUnique({
              name: uniqueConstraint.name,
              columnNames: uniqueConstraint.columnNames,
            }));
          }
        });
      }

      // Recreate foreign keys
      if (table?.foreignKeys) {
        table?.foreignKeys.forEach(fk => {
          newTable.addForeignKey(new TableForeignKey({
            columnNames: fk.columnNames,
            referencedTableName: fk.referencedTableName,
            referencedColumnNames: fk.referencedColumnNames,
            onDelete: fk.onDelete,
            onUpdate: fk.onUpdate,
          }));
        });
      }

      // Recreate indexes (including unique indexes)
      if (table?.indexes) {
        table?.indexes.forEach(index => {
          const tableIndex = new TableIndex({
            name: index.name,
            columnNames: index.columnNames,
            isUnique: index.isUnique,  // Ensure to preserve uniqueness
          });
          newTable.addIndex(tableIndex);
        });
      }
      // Create the new table
      await queryRunner.createTable(newTable, true);

      // Copy the data from the old table to the new one (optional)
      await queryRunner.query(`INSERT INTO "ranking_temp" SELECT * FROM "ranking"`);

      // Drop the old table
      await queryRunner.query('DROP TABLE "ranking"');

      // Rename the new table to the old name
      await queryRunner.query('ALTER TABLE "ranking_temp" RENAME TO "ranking"');
    }
  }

  exportDatabase() {
    // console.log(this.connection);
    const buffer = this.connection.driver.databaseConnection.export();

    const blob = new Blob([buffer]);
    const a = document.createElement('a');
    a.href = window.URL.createObjectURL(blob);
    const fileName = 'export_' + moment().format('YYYYMMDD_HHmmss') + '.db';
    a.download = fileName;
    a.onclick = () => {
      setTimeout(() => {
        window.URL.revokeObjectURL(a.href);
      }, 1500);
    };
    a.click();
  }

  vacuum() {
    return getConnection().query('VACUUM;');
  }

  async setSynchroState(state: 'ok' | 'ko') {
    const repo = getRepository(Check);
    let check = await repo.findOne({ name: 'synchro_state' });
    if (!check) {
      check = new Check();
      check.name = 'synchro_state';
    }
    check.value = state;

    repo.save(check, { transaction: false });
  }

  async synchronizeCheckIsOK() {
    const repo = getRepository(Check);
    const check = await repo.findOne({ name: 'synchro_state' });
    // console.log(check);
    return check.value === 'ok' || false;
  }
}
